export enum List {
    rowPerPage = 'Broj redova na stranici',
    of = ' od ',
}

export enum Action {
    Edit = 'Izmena',
    Delete = 'Brisanje',
    Close = 'Zatvori'
}

export enum SubmitButton {
    save = 'Sačuvaj',
    update = 'Izmeni'
}